module.exports = __webpack_public_path__ + "img/oni.a0d2075a.jpeg";